import {actions} from '../modules/Auth'
import {actions as reduxFormActions} from 'redux-form'
import SostaOnlineApiService from '../../services/SostaOnlineApiService'

const HOST = SostaOnlineApiService.HOST;

const getHeaders = (
    options = {
        contentType: 'application/json'
    }) => {
    let opts = {
        contentType: options.contentType || 'application/json; charset=UTF-8',
        authorization: options.authorization || null
    };
    let headers = {};
    if(opts.contentType) {
        headers['Content-Type'] = opts.contentType;
    }
    if(opts.authorization) {
        headers['Authorization'] = "Bearer " + opts.authorization;
    }
    return headers;
};

const baseFetch = (url, method, body = null, headers = {}) => {
    return fetch(url , {
        method: method,
        headers: getHeaders(headers),
        body: body
    }).then((response) => {
        if(response.status >= 200 && response.status < 300) {
            return response.json();
        } else {
            throw new Error(response);
            //return response.json().then(Promise.reject.bind(Promise));
        }
    });
};

const login = (credentials) => {
    return baseFetch(HOST + '/wp-json/jwt-auth/v1/token', "POST", credentials);
};

/*
$fetch request
{
  type: string,
  $fetch: {
    url: string,
    method: string,
    body: string
  }
}

$api request
{
  type: string,
  api: {
    method: string,
    body: string
  }
}
*/
export default store => next => action => {

    if(!action.$fetch && !action.$api) {
        return next(action);
    }

    next(action);

    if(action.$fetch) {
        // fetch REQUEST
        next({
            type: action.type + "/REQUEST",
            payload: action.payload,
            data: action.$fetch
        });

        baseFetch(HOST + action.$fetch.url, action.$fetch.method, action.$fetch.body, {
            contentType: action.$fetch.contentType ? action.$fetch.contentType : 'application/json',
            authorization: store.getState().auth.token
        }).then(data => {
            return next({
                type: action.type + "/SUCCESS",
                payload: action.payload,
                data: data
            });
        }).catch(err => {
            if(err.status === 401) {
                store.dispatch(actions.logout());
            }
            err.json().then(data => next({
                type: action.type + "/FAILURE",
                data: {
                    body: data,
                    status: err.status
                },
                payload: action.payload
            }));
        });
    } else {
        // api REQUESTS
        next({
            type: action.type + "/REQUEST",
            data: action.$api
        });

        switch (action.$api.method) {
            case "login":
                baseFetch(HOST + '/api/v1/auth/login', "POST", JSON.stringify(action.$api.body)).then(data => {
                    store.dispatch(reduxFormActions.stopSubmit('login', {}));
                    next({
                        type: action.type + "/SUCCESS",
                        data: data,
                    });

                    SostaOnlineApiService.setToken(data.data.token);
                    store.dispatch({
                        type: "FETCH_MIDDLEWARE/LOGIN_SUCCESS_REDIRECT",
                        $redirect: {
                            location: '/'
                        }
                    });

                    return next({
                        type: "FETCH_MIDDLEWARE/LOGIN_SUCCESS",
                    });
                }).catch(err => {
                    store.dispatch(reduxFormActions.stopSubmit('login', {_error: 'E-mail o Codice Fiscale o password errati'}));
                    return next({
                        type: action.type + "/FAILURE",
                        data: err
                    });
                });
                return;
            case "logout":
                next(action);
                store.dispatch({
                    type: "FETCH_MIDDLEWARE/LOGOUT_SUCCESS_REDIRECT",
                    $redirect: {
                        location: '/'
                    }
                });

                return next({
                    type: "FETCH_MIDDLEWARE/LOGOUT_SUCCESS",
                });
                return;
        }
    }
};


// WEBPACK FOOTER //
// ./src/redux/middlewares/fetch.js